var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.user)?_c('navbar',{attrs:{"title":_vm.user.attributes.given_name
        ? `${_vm.user.attributes.given_name}'s SongPad`
        : `${_vm.user.attributes.name}'s SongPad`,"show-back-button":false}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }